import { Component } from '@angular/core';

@Component({
  selector: 'op-exchange-rate-amount-content',
  templateUrl: './exchange-rate-amount-content.component.html',
})
export class ExchangeRateAmountContentComponent {
}